import { CircularProgress, Stack, Typography } from '@mui/material';

export const LoadingView = () => {
  return (
    <Stack direction="column" alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
      <CircularProgress />
      <Typography>Loading&hellip;</Typography>
    </Stack>
  );
};
